import { client } from '../client';
import { FETCH_ACTIVITYS } from '../queries/actions/activitys';
import { FETCH_PREDEFINED_ORDERS } from '../queries/orders/predefinedData';
import {
  resolveLaneCutIds,
  EMPTY_LANE_CUT_IDS,
  type LaneCutIds,
} from '../../utils/laneCut';

/**
 * Carga los catálogos y devuelve los ids que son corte de carril.
 *
 * `cache-first` y no `readQuery`: `readQuery` devuelve null si la query nunca se
 * ejecutó, y `FETCH_ACTIVITYS` no siempre está en caché — el selector de
 * actuaciones resuelve el nombre de la actividad con `GET_ACTIVITY_BY_ID` por
 * fila, que no llena la lista. Con `cache-first` se pide una vez y a partir de
 * ahí sale de caché.
 *
 * Es UNA llamada por lote de filas, no por fila.
 *
 * Multi-tenant: ambas queries pasan por `getReusableArrayFilter(tenantId)` en el
 * backend, así que solo llegan los catálogos globales y los del tenant actual.
 */
export const loadLaneCutIds = async (): Promise<LaneCutIds> => {
  try {
    const [activitys, predefined] = await Promise.all([
      client.query({ query: FETCH_ACTIVITYS, fetchPolicy: 'cache-first' }),
      client.query({ query: FETCH_PREDEFINED_ORDERS, fetchPolicy: 'cache-first' }),
    ]);
    return resolveLaneCutIds(
      activitys?.data?.activitys,
      predefined?.data?.predefinedOrders,
    );
  } catch {
    // Sin catálogo (offline, error de red) el criterio degrada al flag booleano,
    // que viaja en el propio fragment. Nunca revienta la tabla.
    return EMPTY_LANE_CUT_IDS;
  }
};
